import { toComparablePrice } from "./priceFilter"

const filterOptions = [
  { name: "job_type", multiple: true },
  { name: "kind", multiple: true },
  { name: "brand", multiple: true },
  { name: "fuel", multiple: true },
  { name: "priceRanges", multiple: true },
  { name: "duration", multiple: true },
  { name: "transmission" },
  { name: "tags", multiple: true },
  { name: "province", multiple: true },

  { name: "kilometers", multiple: true },
  { name: "maxPrice" },
  { name: "minPrice" }
]

const numericFilters = new Set(["minPrice", "maxPrice"])

export default function getFiltersFromQuery(query) {
  const filters = {}

  filterOptions.forEach(({ name: filter, multiple }) => {
    const value = query[filter]

    if (!value) return

    if (numericFilters.has(filter)) {
      const parsed = toComparablePrice(Array.isArray(value) ? value[0] : value)
      if (parsed !== null) filters[filter] = parsed
      return
    }

    filters[filter] = multiple && typeof value === "string" ? value.split(",") : value
  })

  return filters
}
